import { createI18n } from '@learnforge/i18n';
import { locales, type FinanceKey } from './locales';

export const i18n = createI18n<FinanceKey>({
  gameId: 'finance',
  locales,
});
